import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController} from '@ionic/angular';

@Component({
    selector: 'modal-configure-geo',
    templateUrl: 'modal-configure-geo.html',
    styleUrls:['./modal-configure-geo.scss']
})
export class ModalConfigureGeoComponent {

    option: any = null;

    constructor(
        private viewCtrl: ModalController,
        private router:Router) {
            const nav = this.router.getCurrentNavigation();
            const state = nav?.extras?.state || {};
            this.option = state["option"];
    }

    onDismiss(option) {
        this.viewCtrl.dismiss(option);
    }

    onBackMenu() {
        this.onDismiss(this.option);
    }

    onSave() {
        this.option.applause = Boolean(this.option.applause);
        this.option.autoPause = Boolean(this.option.autoPause);
        this.option.placement = Boolean(this.option.placement);
        this.option.google = Boolean(this.option.google);
        this.onDismiss(this.option);
        console.log('this.option: ', this.option);
    }
}
